import React, { useState } from 'react'
import './Hairtransplant.css'
import Header from '../../Header/header'
import { RiArrowRightSLine } from 'react-icons/ri'
import Whatsapp from '../../Whatsapp/Whatsapp'
import { Helmet } from 'react-helmet'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const Hairtransplant = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const faqData = [
    {
      question: 'Is hair transplant permanent?',
      answer:
        'Yes. Hair transplantation is always permanent from the same area of your head because it comes from genetically resistant donor sites.',
    },
    {
      question: 'Does it hurt to have a hair transplant?',
      answer: 'No, most people feel no pain at all.',
    },
    {
      question: 'How long does recovery take?',
      answer: 'The majority of patients recover within 5-7 days. Temporary redness or swelling may persist for a little while longer.',
    },
    {
      question: 'When will I start to see results?',
      answer: 'Growth tends to begin after around 3-4 months, with full results taking 8 – 12 months after surgery.',
    },
    {
      question: 'Are there side effects?',
      answer:
        'Sometimes temporary swelling, redness, and mild discomfort can occur – but they are rare when only specialists are working in this area.',
    },
    {
      question: 'What is the cost of a hair transplant in Pitampura?',
      answer: 'A consultation is necessary for precise pricing. The cost depends on the number of grafts required and their implementation method.',
    },
  ]

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }
  return (
    <div className='asthmacontent'>
      <Helmet>
        <title> Hair Transplant Clinic in Pitampura | Natural Results</title>
        <meta
          name='description'
          content='Looking for a trusted hair transplant clinic in Pitampura? Get advanced FUE treatment, natural hairline design, and safe procedures with long-lasting results. Book your consultation today.'
        />
      </Helmet>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='hairtransplanthero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Hair Transplant
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Hair Transplant Clinic in Pitampura | Natural Results
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for a trusted hair transplant clinic in Pitampura? Get advanced FUE treatment, natural hairline design, and safe procedures
                with long-lasting results. Book your consultation today.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>
                We are the Best Hair Transplant Clinic in Pitampura – Advanced & Natural Results
              </h2>
              <p>
                It might make you lose confidence and personality, then your whole appearance. The untimely treatment of hair loss will never do
                anything to harm either your hair or your self-esteem. Whether you suffer from a receding hairline, thinning crown, or pattern
                baldness, it&apos;s all the same--。 When you are searching for a trusted hair transplant clinic in Pitampura, then this is the place
                to be.
              </p>
              <p>
                Our advanced, safe and result-oriented hair transplant procedures are performed to provide natural-looking density and long-lasting
                outcomes.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>A Hair Transplant System That&apos;s Modern</h3>
              <p>
                In our Pitampura hair transplant clinic, we utilize cutting-edge techniques to cause the least pain and fastest recovery. Every
                treatment starts with intensive consultation to understand:
              </p>
              <ul>
                <li>Hair-loss pattern</li>
                <li>Donor area strength</li>
                <li>Medical history</li>
                <li>Lifestyle factors</li>
                <li>Desired hairline design</li>
              </ul>
              <p>We then recommend the most suitable procedure under assessment.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Advantages of Our Hair Transplant Clinic in Pitampura</h3>
              <ul>
                <li>Advanced FUE technology</li>
                <li>Natural hairline design</li>
                <li>Experienced hair restoration specialists</li>
                <li>A clean and safe environment</li>
                <li>Tailored treatment planning</li>
                <li>Follow-up care support.</li>
              </ul>
              <p>
                In order to achieve Hair Transplant Clinic&apos;s goal of not only inducing hair regrowth but also producing balanced, realistic,
                artistically beautiful results
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Who is Suitable for Hair Transplantation?</h3>
              <p>You may be a candidate for hair transplantation if:</p>
              <ul>
                <li>You have male or female pattern hair loss</li>
                <li>You have adequate donor hair at the back of your scalp</li>
                <li>Hair loss has stabilized</li>
                <li>You are aged 21 or over</li>
                <li>You are fit to undergo minor medical procedures</li>
              </ul>
              <p>We help in determining whether an approach to tackle your problems is suitable for you or not.</p>
              <p>
                If you are looking for a reliable Hair Transplant Clinic in Pitampura, book your consultation today to discover the first step towards
                regaining your confidence.
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Sweta Mishra'
              specialty='Maxillofacial Aesthetic Surgeon'
              education='MDS, FAM, Dip. in Aesthetic Medicine'
              image={doc_img}
              blurb="Dr. Sweta Mishra, super-specialized in hair transplantation, performs hair restoration procedures at Sharva Clinique tailored to each patient's hair loss pattern."
              profileLink='/drSweta/transplant'
            />

            <div className='faq-container'>
              <h2 className='faq-title'>Frequently Asked Questions</h2>

              <div className='faq-list'>
                {faqData.map((item, index) => (
                  <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                    <div className='faq-question' onClick={() => toggleFAQ(index)}>
                      <h3>{item.question}</h3>
                      <span className='faq-icon'>{activeIndex === index ? '−' : '+'}</span>
                    </div>

                    <div className='faq-answer-wrapper'>
                      <div className='faq-answer'>
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>
            <div className='card1'>
              <p>“Professional, friendly, and knowledgeable team. I had a great experience and the outcome exceeded my expectations.”</p>
              <p> — Neha </p>
            </div>
            <div className='card2'>
              <p>“Excellent clinic and fantastic results. The whole process was smooth and I felt in good hands the entire time.”</p>
              <p>— Rohan </p>
            </div>
            <div className='card3'>
              <p>“Great experience overall. The doctor explained realistic expectations and delivered exactly what was promised.”</p>
              <p> — Manish</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hairtransplant
